import type { ReactNode } from 'react';

import { Button, Dialog } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { useMoTaLoi } from '../../hooks/useMoTaLoi';

export interface HopXacNhanProps {
  open: boolean;
  onClose: () => void;
  /** Tiêu đề đặt câu hỏi: `Xoá nguồn «Kế toán»?`. */
  tieuDe: string;
  /** Thân nói hậu quả và tính không hoàn tác. */
  than: ReactNode;
  /** Nhắc lại việc sắp xảy ra: `Xoá nguồn`, không phải `OK`. */
  nhanXacNhan: string;
  dangChay: boolean;
  loi?: unknown;
  /** `false` cho việc không phá huỷ (đổi chế độ, xoay khoá) — nút chính không tô đỏ. */
  phaHuy?: boolean;
  /** Khoá nút xác nhận khi điều kiện chưa đủ (chưa gõ lại tên…). */
  khoa?: boolean;
  onXacNhan: () => void;
}

/**
 * Hộp xác nhận của module (thay `window.confirm` của native — CLAUDE.md cấm `alert()`/tự dựng modal).
 *
 * Giữ hộp **mở** khi lỗi: câu giải thích của máy chủ (409 bot đang dùng nguồn…) phải đọc được ngay tại chỗ người dùng vừa
 * bấm, không phải ở một toast đã biến mất.
 */
export function HopXacNhan({
  open, onClose, tieuDe, than, nhanXacNhan, dangChay, loi, phaHuy = true, khoa, onXacNhan,
}: HopXacNhanProps) {
  const { t } = useT();
  const moTaLoi = useMoTaLoi();
  return (
    <Dialog open={open} onClose={onClose} title={tieuDe}>
      <div className="space-y-4 pt-2">
        <div className="text-sm text-content-secondary">{than}</div>
        {loi ? (
          <p role="alert" className="rounded border border-danger-100 bg-danger-50 p-3 text-sm text-danger-700">
            {moTaLoi(loi)}
          </p>
        ) : null}
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant={phaHuy ? 'destructive' : 'primary'}
            size="md"
            loading={dangChay}
            disabled={khoa}
            onClick={onXacNhan}
          >
            {nhanXacNhan}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
